<mat-card class="mat-card profile-card">
  <div class="row" fxLayoutAlign="space-between center">
    <h2 class="card-title">
      {{ '365-USER-PAGE.CARD-TITLE.MICROSOFT-GROUPS-TITLE' | translate }}
    </h2>
    <img
      src="../../../assets/images/maintenance/services/OFFICE.svg"
      class="indices"
      alt="{{ 'GENERAL.SERVICE_IMAGE' | translate }}" />
  </div>
  @if (userId) {
    @if (isBusy) {
      <div
        class="general-container"
        fxLayout="row"
        fxLayoutAlign="center center">
        <mat-progress-spinner
          [color]="spinner.color"
          [mode]="spinner.mode"
          [value]="spinner.value"
          [diameter]="spinner.diameter">
        </mat-progress-spinner>
      </div>
    } @else if (this.microsoftGroupsUser.length > 0) {
      <div class="search-section">
        <div class="search-field">
          <div class="search-wrapper">
            <div
              class="search"
              fxFlex
              fxLayout="row"
              fxLayoutAlign="start center">
              <mat-icon>search</mat-icon>
              <input
                autoComplete="on"
                #filter
                [formControl]="groupsNameFilter"
                matInput
                placeholder="{{
                  '365-USER-PAGE.GROUPS.SEARCH-NAME-FIELD' | translate
                }}" />
            </div>
          </div>
          <div class="search-wrapper">
            <div
              class="search"
              fxFlex
              fxLayout="row"
              fxLayoutAlign="start center">
              <mat-icon>search</mat-icon>
              <input
                autoComplete="on"
                #filter
                [formControl]="groupsMailFilter"
                matInput
                placeholder="{{
                  '365-USER-PAGE.GROUPS.SEARCH-MAIL-FIELD' | translate
                }}" />
            </div>
          </div>
        </div>
      </div>
      @if (dataSourceGroups.filteredData.length > 0) {
        <table
          mat-table
          matSort
          multiTemplateDataRows
          [dataSource]="dataSourceGroups">
          <ng-container matColumnDef="photo">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let group">
              <div class="displayImage">
                <img
                  src="../../../../assets/images/maintenance/services/OFFICE.svg"
                  class="serviceImage"
                  alt="{{ 'GENERAL.SERVICE_IMAGE' | translate }}" />
                @if (group.hasTeam) {
                  <img
                    src="../../../../assets/images/maintenance/services/TEAMS.svg"
                    class="smallTeamsImage"
                    alt="Teams Icon" />
                }
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="displayName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ '365-USER-PAGE.GROUPS.NAME' | translate }}
            </th>
            <td mat-cell *matCellDef="let group">{{ group.displayName }}</td>
          </ng-container>

          <ng-container matColumnDef="mail">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ '365-USER-PAGE.GROUPS.MAIL' | translate }}
            </th>
            <td mat-cell *matCellDef="let group">{{ group.mail }}</td>
          </ng-container>

          <ng-container matColumnDef="view">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let group">
              <button
                mat-icon-button
                (click)="redirectToGroup(group.id, false)">
                <mat-icon>open_in_new</mat-icon>
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="expand">
            <th mat-header-cell *matHeaderCellDef aria-label="row actions">
              &nbsp;
            </th>
            <td mat-cell *matCellDef="let group">
              <button
                mat-icon-button
                aria-label="expand row"
                (click)="
                  expandedUserGroup =
                    expandedUserGroup === group ? null : group;
                  $event.stopPropagation()
                ">
                <mat-icon>more_horiz</mat-icon>
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="expandedDetail">
            <td
              mat-cell
              *matCellDef="let group"
              [attr.colspan]="displayedColumnsGroups.length">
              <div class="user-group-detail">
                @if (hiddenColumns.includes('mail')) {
                  <div class="user-group-mail">
                    <div class="title">
                      {{ '365-USER-PAGE.GROUPS.MAIL' | translate }} :
                    </div>
                    <div class="content">{{ group.mail }}</div>
                  </div>
                }
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsGroups"></tr>
          <tr
            mat-row
            *matRowDef="let group; columns: displayedColumnsGroups"
            (click)="redirectToGroup(group.id, true)"></tr>
          <tr
            mat-row
            *matRowDef="let group; columns: ['expandedDetail']"
            [class.show-hide]="expandedUserGroup !== group"></tr>
        </table>
      } @else {
        <h1 class="no-item">
          {{ '365-USER-PAGE.GROUPS.NOTHING-FILTERED' | translate }}
        </h1>
      }
      <div [hidden]="isBusy || dataSourceGroups.filteredData.length === 0">
        <mat-paginator
          class="paginator"
          [pageSize]="5"
          [hidePageSize]="true"
          showFirstLastButtons>
        </mat-paginator>
      </div>
    } @else if (
      !isBusy &&
      (dataSourceGroups.filteredData.length === 0 ||
        this.microsoftGroupsUser.length === 0)
    ) {
      <h1 class="no-item">{{ '365-USER-PAGE.GROUPS.NOTHING' | translate }}</h1>
    }
  } @else {
    <div class="general-container" fxLayout="row" fxLayoutAlign="center center">
      <mat-progress-spinner
        [color]="spinner.color"
        [mode]="spinner.mode"
        [value]="spinner.value"
        [diameter]="spinner.diameter">
      </mat-progress-spinner>
    </div>
  }
</mat-card>
